import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { FieldArray, Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { Card as CardBootstrap, Badge, Table } from "react-bootstrap";
import { Card } from "primereact/card";
import Illustration from "../../../../../partials/content/Illustration";
import { Accordion, AccordionTab } from "primereact/accordion";
import {
  formatDate,
  onPreventEnterSubmitting,
} from "../../../../../utils/utils";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import SearchJourneyTeam from "../searchJourneyTeam";
import TaskDetail from "../../../users/tasks/taskDetail";
import {
  getVisitActivityTasks,
  saveActivityTasks,
} from "../../../../../services/crm/salesJourney";
import Swal from "sweetalert2";
import TaskForm from "../../../users/tasks/taskForm";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { CustomSelectField } from "../../../../../partials/content/Forms";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import { isMobile } from "react-device-detect";
function ActivityTaskForm({ history, match }) {
  const { journeyID = 0, visitActivityID = 0 } = match.params;
  const [visitActivity, setVisitActivity] = useState({
    ID: 0,
    activityID: 0,
    activityName: 0,
    statusID: 0,
    statusName: "",
    visit: {
      leadID: 0,
      lead: {
        leadName: "",
      },
      customerID: 0,
      customer: {
        customerName: "",
      },
    },
  });
  const [itemIndex, setItemIndex] = useState(-1);
  const [salesActivityOptions, setSalesActivityOptions] = useState([]);
  const [activityStatusOptions, setActivityStatusOptions] = useState([]);
  const [tasksData, setTasksData] = useState({
    visitActivityID: 0,
    activityID: 0,
    activityName: "",
    statusID: 0,
    statusName: "",
    note: "",
    tasks: [],
  });
  const [openSearchTeam, setOpenSearchTeam] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const taskSchema = yup.object().shape({
    tasks: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        visitActivityID: yup.number(),
        title: yup
          .string()
          .required("Task Title is required")
          .max(255, "Task Title maximum characters is 255"),
        userID: yup.number(),
        userName: yup.string().required("Username is required"),
        statusID: yup.number(),
        statusDesc: yup.string(),
        description: yup.string(),
        deadlineDate: yup.date().required("Deadline Date is required"),
      })
    ),
  });
  const [openTaskDetail, setOpenTaskDetail] = useState(false);
  const [task, setTask] = useState({});
  const [openTaskForm, setOpenTaskForm] = useState(false);
  useEffect(() => {
    getVisitActivityTasksData(visitActivityID);
  }, [visitActivityID]);
  return (
    <Formik
      initialValues={tasksData}
      enableReinitialize={true}
      validateOnChange={false}
      validationSchema={taskSchema}
      onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Activity Tasks ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveActivityTasks(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        dirty,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <PageSubHeader
            title={"Visit Activity Tasks"}
            breadcrumbs={[
              { page: "/menu", title: "Menu", active: false },
              {
                page: "/crm/sales-journey",
                title: "Sales Journeys",
                active: false,
              },
              {
                page: "/crm/journey-detail/" + journeyID,
                title: "Sales Journey ID " + journeyID,
                active: false,
              },
              {
                page: "/crm/visit-detail/" + visitActivity.visitID,
                title: `Visit ID ${visitActivity.visitID} ${
                  visitActivity.visit.customerID > 0
                    ? visitActivity.visit.customer.customerName
                    : visitActivity.visit.leadID > 0
                    ? visitActivity.visit.lead.leadName
                    : ""
                }`,
                active: false,
              },
              {
                page: `/crm/visit-activity-tasks/${journeyID}/${visitActivityID}`,
                title: "Visit Activity Detail ID " + visitActivityID,
                active: true,
              },
            ]}
            actionButtons={[
              {
                title: "",
                color: "label-brand",
                icon: "fas fa-backward",
                onClick: () => {
                  history.push("/crm/visit-detail/" + visitActivity.visitID);
                },
              },
            ]}
            saveButton={{
              showButton: true,
              onClick: (e) => {
                handleSubmit(e);
              },
            }}
          />
          <ContentLayout>
            <CardBootstrap className="mb-3">
              <CardBootstrap.Header>
                <i className="fas fa-window-maximize"></i>
                <span>
                  <strong>Visit Activity Header</strong>
                </span>
              </CardBootstrap.Header>
              <CardBootstrap.Body>
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <CustomSelectField
                      label="Activity"
                      propertyName="activityID"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      values={values}
                      touched={touched}
                      errors={errors}
                      options={salesActivityOptions}
                    />
                  </div>
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <CustomSelectField
                      label="Status"
                      propertyName="statusID"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      values={values}
                      touched={touched}
                      errors={errors}
                      options={activityStatusOptions}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6 col-md-6 col-lg-6">
                    <strong>Note</strong>
                    <textarea
                      rows={5}
                      style={{ resize: "none" }}
                      onChange={(e) => {
                        setFieldValue("note", e.target.value);
                      }}
                      className="form-control"
                      value={values.note}
                    />
                  </div>
                </div>
              </CardBootstrap.Body>
            </CardBootstrap>
            <div className="accordion">
              <div className="card">
                <Accordion
                  className="accordion"
                  activeIndex={activeIndex}
                  onTabChange={(e) => setActiveIndex(e.index)}
                >
                  <AccordionTab
                    header={
                      <React.Fragment>
                        <i className="fas fa-sitemap"></i>
                        <span>
                          <strong>Activity Task Items</strong>
                        </span>
                      </React.Fragment>
                    }
                  >
                    {isMobile ? (
                      <React.Fragment>
                        {values.tasks.map((taskData, index) => (
                          <div
                            key={index}
                            onClick={() => {
                              setTask(taskData);
                              setOpenTaskDetail(true);
                            }}
                          >
                            <Card title={taskData.title}>
                              <table>
                                <tr>
                                  <td>
                                    {taskData.statusID === 1 ? (
                                      <Badge variant="primary">
                                        {taskData.statusDesc}
                                      </Badge>
                                    ) : (
                                      <Badge variant="info">
                                        {taskData.statusDesc}
                                      </Badge>
                                    )}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr>
                                  <th>Assigned To</th>
                                  <td>{taskData.userName}</td>
                                </tr>
                                <tr>
                                  <th>Deadline Date</th>
                                  <td>{formatDate(taskData.deadlineDate)}</td>
                                </tr>
                              </table>
                            </Card>
                          </div>
                        ))}
                      </React.Fragment>
                    ) : (
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <FieldArray name="visitActivities">
                            {({ push, remove }) => (
                              <React.Fragment>
                                <div className="row">
                                  <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="card">
                                      <Table size="sm" responsive="xl">
                                        {values.tasks &&
                                        values.tasks.length > 0 ? (
                                          <thead>
                                            <tr>
                                              <th>Task Title</th>
                                              <th>Assigned To</th>
                                              <th>Deadline Date</th>
                                              <th>Status</th>
                                              <th>Actions</th>
                                            </tr>
                                          </thead>
                                        ) : null}
                                        <tbody>
                                          {values.tasks &&
                                          values.tasks.length > 0 ? (
                                            values.tasks.map(
                                              (taskData, index) => {
                                                return (
                                                  <tr key={index}>
                                                    <td>{taskData.title}</td>
                                                    <td>{taskData.userName}</td>
                                                    <td>
                                                      {formatDate(
                                                        taskData.deadlineDate
                                                      )}
                                                    </td>
                                                    <td>
                                                      {taskData.statusID ===
                                                      1 ? (
                                                        <Badge variant="primary">
                                                          {taskData.statusDesc}
                                                        </Badge>
                                                      ) : (
                                                        <Badge variant="info">
                                                          {taskData.statusDesc}
                                                        </Badge>
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{
                                                        whiteSpace: "nowrap",
                                                      }}
                                                      className="text-center"
                                                    >
                                                      <BootstrapTooltip title="Task Detail">
                                                        <button
                                                          type="button"
                                                          className="btn btn-icon btn-label-success btn-md btn-circle mx-1"
                                                          style={{
                                                            marginRight: "5px",
                                                          }}
                                                          onClick={() => {
                                                            setTask(taskData);
                                                            setOpenTaskDetail(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          <i className="fas fa-list-alt"></i>
                                                        </button>
                                                      </BootstrapTooltip>
                                                      <BootstrapTooltip
                                                        title={
                                                          taskData.deleteInd &&
                                                          taskData.ID > 0
                                                            ? "Undo Delete"
                                                            : "Delete Task Item"
                                                        }
                                                      >
                                                        <button
                                                          type="button"
                                                          className={`btn btn-icon btn-label-${
                                                            taskData.deleteInd
                                                              ? "warning"
                                                              : "danger"
                                                          } btn-md btn-circle mx-1`}
                                                          onClick={() => {
                                                            if (
                                                              taskData.ID > 0
                                                            ) {
                                                              setFieldValue(
                                                                `data[${index}].deleteInd`,
                                                                !taskData.deleteInd
                                                              );
                                                            } else {
                                                              remove(index);
                                                            }
                                                          }}
                                                        >
                                                          {taskData.deleteInd &&
                                                          taskData.ID > 0 ? (
                                                            <i className="fas fa-undo-alt"></i>
                                                          ) : (
                                                            <i className="fas fa-trash-alt"></i>
                                                          )}
                                                        </button>
                                                      </BootstrapTooltip>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                className="text-center py-3"
                                                colSpan="5"
                                              >
                                                <Illustration
                                                  imageSource="INVIFO CRM.png"
                                                  guidance="You don't have any Activity Task items yet"
                                                  guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                                  size="sm"
                                                ></Illustration>
                                              </td>
                                            </tr>
                                          )}
                                          <tr>
                                            <td
                                              className="text-center py-3"
                                              colSpan="5"
                                            >
                                              <button
                                                type="button"
                                                className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                                                onClick={() => {
                                                  setTask({});
                                                  setOpenTaskForm(true);
                                                }}
                                              >
                                                <i className="fas fa-plus-circle"></i>
                                                Add Task
                                              </button>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </Table>
                                    </div>
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                          </FieldArray>
                        </div>
                      </div>
                    )}
                  </AccordionTab>
                </Accordion>
              </div>
            </div>
          </ContentLayout>
          <DialogLayout
            open={openTaskForm}
            title="Task Form"
            onCloseDialog={handleCloseTaskForm}
            maxWIdth="lg"
          >
            <TaskForm
              task={task}
              journeyID={journeyID}
              visitActivity={visitActivity}
              onConfirmSave={() => {
                getVisitActivityTasksData(visitActivity.ID);
                handleCloseTaskForm();
              }}
              onCloseDialog={handleCloseTaskForm}
            />
          </DialogLayout>
          <DialogLayout
            open={openTaskDetail}
            title="Task Detail"
            onCloseDialog={() => {
              getVisitActivityTasksData(visitActivity.ID);
              handleCloseTaskDetail();
            }}
            maxWIdth="lg"
          >
            <TaskDetail taskID={task.ID} journeyID={journeyID} />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={() => {
                  getVisitActivityTasksData(visitActivity.ID);
                  handleCloseTaskDetail();
                }}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
          <DialogLayout
            open={openSearchTeam}
            title="Journey Teams"
            onCloseDialog={handleCloseSearchTeam}
            maxWIdth="sm"
          >
            <SearchJourneyTeam
              journeyID={journeyID}
              onSelectUser={(team) => {
                setFieldValue(`data[${itemIndex}].userID`, team.user.ID);
                setFieldValue(`data[${itemIndex}].userName`, team.userName);
                handleCloseSearchTeam();
              }}
            />
            <DialogActions>
              <button
                type="button"
                className="btn btn-label-danger btn-md btn-pill btn-bold"
                onClick={handleCloseSearchTeam}
              >
                <i className="fas fa-window-close"></i>
                Close
              </button>
            </DialogActions>
          </DialogLayout>
        </form>
      )}
    </Formik>
  );
  function handleCloseTaskForm() {
    setOpenTaskForm(false);
  }

  function handleCloseTaskDetail() {
    setOpenTaskDetail(false);
  }

  function handleCloseSearchTeam() {
    setOpenSearchTeam(false);
  }

  async function getVisitActivityTasksData(visitActivityID) {
    const response = await getVisitActivityTasks(visitActivityID);
    const { data } = response.data;
    setVisitActivity(data.visitActivity);
    setTasksData({
      visitActivityID: data.visitActivity.ID,
      activityID: data.visitActivity.activityID,
      activityName: data.visitActivity.activityName,
      statusID: data.visitActivity.statusID,
      statusName: data.visitActivity.statusName,
      note: data.visitActivity.note,
      tasks: data.tasks,
    });
    setSalesActivityOptions(data.salesActivityOptions);
    setActivityStatusOptions(data.activityStatusOptions);
  }
}

export default ActivityTaskForm;
